import { Button, ButtonSizes, ButtonVariants, Heading1, Heading2, Text } from "@roc-digital/ui-web";
import { Input } from '@/components/elements';
import React from "react";
import ReactDatePicker from "react-datepicker";

interface ExtendSubscriptionDateProps {
  date: Date;
  onSave: (date: Date) => void;
  onCancel: () => void;
}

export function ExtendSubscriptionDate(props: ExtendSubscriptionDateProps) {
  const [date, setDate] = React.useState(props.date);

  const canSave = true;

  return <Container title="Extend Subscription">
    <div className="flex flex-row gap-4">
      <div>
        Change the current subscription end date. This will override the current subscription, if it exists.
      </div>
      <ReactDatePicker
        selected={date || new Date()}
        onChange={(v) => setDate(v || new Date(0))}
        placeholderText={'Select'}
        popperPlacement={"right-start"}
        // startOpen
        // inline
      />
      <div className="min-h-[300px]"></div>
    </div>
    <div className="flex flex-row" style={{gap: 4}}>
      <div className="flex-grow"></div>
      <Button
        variant={ButtonVariants.secondary}
        size={ButtonSizes.small}
        clickEvent={props.onCancel}>Cancel</Button>
      <Button
        disabled={canSave !== true}
        variant={ButtonVariants.primary}
        size={ButtonSizes.small}
        clickEvent={() => props.onSave(date)}
      >Save</Button>
    </div>
  </Container>
}

interface ContainerProps {
  title: string;
  children: any;
}

function Container(props: ContainerProps) {
  return <div className="p-4 dark:bg-black dark:text-white gap-3 flex flex-col">
  <div className="text-xl w-full font-bold mb-2">{props.title}</div>
    {props.children}
  </div>;
}

